export default __webpack_public_path__ + "static/media/tour-welcome.538fff69.png";